var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCoinbase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_1177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0C37.7562 0 48.5 10.7438 48.5 24C48.5 37.2562 37.7562 48 24.5 48C11.2438 48 0.5 37.2562 0.5 24C0.5 10.7438 11.2438 0 24.5 0Z",
    fill: "#0052FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5047 32.4375C19.8453 32.4375 16.0672 28.6641 16.0672 24C16.0672 19.3359 19.8453 15.5625 24.5047 15.5625C28.6812 15.5625 32.15 18.6094 32.8156 22.5938H41.3141C40.5969 13.9312 33.3453 7.125 24.5 7.125C15.1812 7.125 7.625 14.6812 7.625 24C7.625 33.3188 15.1812 40.875 24.5 40.875C33.3453 40.875 40.5969 34.0688 41.3141 25.4062H32.8109C32.1406 29.3906 28.6812 32.4375 24.5047 32.4375Z",
    fill: "white",
    fillOpacity: 0.87
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_1177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCoinbase);
export default __webpack_public_path__ + "static/media/ic-coinbase.2226ff9002eb826d5499676f184fc4af.svg";
export { ForwardRef as ReactComponent };